import { css, cx } from 'styled-system/css';
import {
  SplitSection,
  splitEntryClass,
} from '../../components/landing/SplitSection';

const billingQuestions = [
  {
    question: 'What counts as a cell edit?',
    answer:
      'Any cell written to the live grid or included in a posted Proposal, by a person or an agent. That covers Autocomplete, Repairer, Formatter, JIT, Routines, and Oracle when it opens a change, and every cell an outside AI client puts in a Proposal over MCP. Oracle answers that change nothing, and format-only changes on the live grid, are free.',
  },
  {
    question: 'Who pays?',
    answer:
      "The document owner, on the owner's plan. One monthly allowance covers the Exis editor and connected Google Sheets. Reading, downloading, and History stay open after the free cell edits run out. On Starter they stay open past the 5,000 too.",
  },
  {
    question: 'How do I pay?',
    answer:
      'Create an Exis account, then buy Starter or start the Pro trial. A Starter subscriber can move to Pro from Billing settings. Checkout runs on Paddle, so Exis never asks for card numbers on its own forms.',
  },
  {
    question: 'Can I cancel?',
    answer:
      'Yes, at any time. Your plan runs to the end of the period you paid for, and your included cell edits keep working until then.',
  },
];

export function BillingQuestions() {
  return (
    <SplitSection
      label="How billing works"
      eyebrow="Billing"
      title="How billing works"
      description="Paddle is our Merchant of Record. It takes the card, handles tax, and sends invoices."
      className={css({
        paddingTop: { base: '20', md: '32' },
        paddingBottom: { base: '16', md: '24' },
      })}
    >
      <dl>
        {billingQuestions.map((item) => (
          <div
            key={item.question}
            className={cx(
              splitEntryClass(),
              css({
                paddingBlock: { base: '5', md: '6' },
              }),
            )}
          >
            <dt
              className={css({
                fontFamily: 'sans',
                fontWeight: 'semibold',
                fontSize: { base: 'md', md: 'lg' },
                letterSpacing: 'tight',
                lineHeight: 'snug',
                color: 'text.primary',
              })}
            >
              {item.question}
            </dt>
            <dd
              className={css({
                marginTop: '3',
                marginInlineStart: '0',
                fontSize: { base: 'base', md: 'md' },
                lineHeight: 'relaxed',
                color: 'text.secondary',
                maxWidth: '62ch',
                textWrap: 'pretty',
              })}
            >
              {item.answer}
            </dd>
          </div>
        ))}
      </dl>
    </SplitSection>
  );
}
